import { Button } from "@/components/ui/button";
import { Plus, Users } from "lucide-react";

interface GuestsEmptyBannerProps {
  onCreate: () => void;
}

const GuestsEmptyBanner = ({ onCreate }: GuestsEmptyBannerProps) => (
  <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center flex flex-col items-center">
    <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />

    <h3 className="text-gray-800 font-medium mb-2">No hay huéspedes</h3>

    <p className="text-gray-600 text-sm mb-4">
      No se encontraron huéspedes en la base de datos.
    </p>

    <Button onClick={onCreate} className="flex items-center gap-2">
      <Plus size={16} />
      Crear Primer Huésped
    </Button>
  </div>
);

export default GuestsEmptyBanner;
